import React, { useState } from "react";
import { LIST_PRESENTATION } from "utils/constants/ui";
import { createUseContext } from "./";

export const {
  Context: ProductContext,
  ContextProvider: ProductContextProvider,
  useContext: useProductContext
  /* eslint-disable-next-line react/display-name, react/prop-types */
} = createUseContext((Provider) => ({ children }) => {
  const [values, setValues] = useState({
    presentation: LIST_PRESENTATION.LIST,
    search: ""
  });

  return (
    <Provider
      value={{
        values,
        setValues
      }}
    >
      {children}
    </Provider>
  );
});
